import { pickupCheckoutModule } from './store/pickup-checkout'
import { paymentModule } from './store/payment'
import { shippingModule } from './store/shipping'
import { beforeRegistration } from './hooks/beforeRegistration'
import { afterRegistration } from './hooks/afterRegistration'
import { createModule } from '@vue-storefront/core/lib/module'

export const KEY = 'pickup-checkout'
export const PickupCheckout = createModule({
  key: KEY,
  store: { modules: [
    { key: 'pickup-shipping', module: shippingModule },
    { key: 'pickup-payment', module: paymentModule },
    { key: 'pickup-checkout', module: pickupCheckoutModule }
  ] },
  beforeRegistration,
  afterRegistration
})
